<div class="device">
  <!-- Top bezel rail: round indicator (menu) + etched wordmark + session action -->
  <header class="rail">
    <button
      type="button"
      class="indicator"
      (click)="toggleMenu()"
      [attr.aria-expanded]="isMenuOpen"
      aria-label="Menu">
      <span class="indicator-glyph" aria-hidden="true"></span>
    </button>

    <span class="wordmark">FLOPSTR</span>
    <!--
      The top-right login/logout rail-action was removed (#676): it duplicated the
      drawer's Login / Logout entries (which carry both an icon and a label). Both
      actions remain reachable from the drawer below.
    -->

    <!-- Alerts (patch notes): illuminates when there are unread entries (#747) -->
    <button
      type="button"
      class="alerts-btn"
      [class.alerts-btn--unread]="hasUnreadAlerts()"
      data-testid="alerts-button"
      (click)="openAlerts()"
      [attr.aria-label]="hasUnreadAlerts() ? 'Alerts, new items' : 'Alerts'">
      <mat-icon aria-hidden="true">campaign</mat-icon>
      <span class="alerts-btn-label">Alerts</span>
    </button>
  </header>

  <!-- Lit, inset screen: every route renders here -->
  <div class="screen">
    <mat-sidenav-container class="screen-inner">
      <mat-sidenav #sidenav [opened]="isMenuOpen" [mode]="'over'" (closed)="closeMenu()" class="drawer">
        <div class="drawer-body">
          <mat-nav-list>
            <div class="user-info" *ngIf="currentUser$ | async as user">
              <mat-icon>account_circle</mat-icon>
              <div class="user-details">
                <span class="user-name">
                  {{ user.name }}
                  <span
                    *ngIf="hasBugReport$ | async"
                    class="bug-reporter-badge"
                    data-testid="bug-reporter-badge"
                    [matTooltip]="'You filed a bug report! You rock!'"
                    matTooltipPosition="above">
                    <span aria-hidden="true">🐛</span>
                  </span>
                </span>
                <button
                  type="button"
                  class="user-email"
                  [class.revealed]="emailRevealed"
                  (click)="toggleEmailReveal()"
                  [attr.aria-label]="emailRevealed ? 'Hide email address' : 'Show email address'"
                  [attr.aria-pressed]="emailRevealed"
                  [title]="emailRevealed ? 'Click to hide' : 'Click to reveal'">
                  {{ user.email }}
                </button>
              </div>
            </div>

            <mat-divider *ngIf="isAuthenticated"></mat-divider>

            <a mat-list-item routerLink="/" (click)="closeMenu()">
              <mat-icon matListItemIcon>home</mat-icon>
              <span matListItemTitle>Home</span>
            </a>

            <a
              mat-list-item
              routerLink="/session"
              (click)="closeMenu()"
              *ngIf="isAuthenticated"
              data-testid="nav-sessions-link">
              <mat-icon matListItemIcon aria-hidden="true">sports_esports</mat-icon>
              <span matListItemTitle>Sessions</span>
            </a>

            <a
              mat-list-item
              routerLink="/saved-lists"
              (click)="closeMenu()"
              *ngIf="isAuthenticated"
              data-testid="nav-saved-lists-link">
              <mat-icon matListItemIcon aria-hidden="true">bookmarks</mat-icon>
              <span matListItemTitle>Saved Lists</span>
            </a>

            <button mat-list-item type="button" *ngIf="isAuthenticated" (click)="openBugReportDialog()">
              <mat-icon matListItemIcon aria-hidden="true">bug_report</mat-icon>
              <span matListItemTitle>Report a Bug</span>
            </button>

            <a
              mat-list-item
              routerLink="/admin"
              (click)="closeMenu()"
              *ngIf="isAdmin$ | async"
              data-testid="nav-admin-link">
              <mat-icon matListItemIcon aria-hidden="true">admin_panel_settings</mat-icon>
              <span matListItemTitle>Admin</span>
            </a>

            <mat-divider></mat-divider>

            <a mat-list-item routerLink="/login" (click)="closeMenu()" *ngIf="!isAuthenticated">
              <mat-icon matListItemIcon>login</mat-icon>
              <span matListItemTitle>Login</span>
            </a>

            <button mat-list-item type="button" (click)="logout()" *ngIf="isAuthenticated">
              <mat-icon matListItemIcon>logout</mat-icon>
              <span matListItemTitle>Logout</span>
            </button>
          </mat-nav-list>

          <!-- Appearance toggle pinned to the foot of the drawer -->
          <div class="appearance">
            <span class="appearance-label" id="appearance-label">Appearance</span>
            <div class="theme-seg" role="group" aria-labelledby="appearance-label">
              <button
                type="button"
                data-testid="theme-dark-btn"
                [class.is-active]="theme() === 'dark'"
                [attr.aria-pressed]="theme() === 'dark'"
                (click)="setTheme('dark')">
                <mat-icon aria-hidden="true">dark_mode</mat-icon>
                <span>Dark</span>
              </button>
              <button
                type="button"
                data-testid="theme-light-btn"
                [class.is-active]="theme() === 'light'"
                [attr.aria-pressed]="theme() === 'light'"
                (click)="setTheme('light')">
                <mat-icon aria-hidden="true">light_mode</mat-icon>
                <span>Light</span>
              </button>
            </div>
          </div>
        </div>
      </mat-sidenav>

      <mat-sidenav-content>
        <div class="content">
          <ng-content></ng-content>
        </div>
        <footer class="app-footer">
          <p class="trademark">Star Wars: Legion™ is a trademark of Lucasfilm Ltd.</p>
          <p class="legal-links">
            <a routerLink="/privacy">Privacy Policy</a>
            <span aria-hidden="true">•</span>
            <a routerLink="/terms">Terms of Service</a>
          </p>
          <p class="app-version" *ngIf="version$ | async as v">v{{ v.fullVersion }}</p>
        </footer>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>
</div>
